
import SvgWrapper from './../../zviz2/zviz/components/svg/wrapper';
import {Controller as GroupController} from './../../zviz2/zviz/components/group';

import BlueprintLoadingSvg from './../../components/elements/loader/svg';
import DefaultInterface from './../../zviz2/zviz/interface';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {default as CircleGroup} from './components/group';
import {getCircles} from './functions';
import state from './../../zviz2/zviz/state';


let PublicInterface = extend({
    isHover: false
}, DefaultInterface);


class Controller extends GroupController{

    constructor(parent, blueprint){
        // if we want to extend the blueprint, we do it in 
        // the definition of the blueprint. This means 
        // blueprint here, is always the full blueprint
        super(parent, blueprint);
        this.implementing(PublicInterface);

        this.isHover = false;

        this.circles = [];

    }

    getSize(type='h'){
        return this.getByUid(this.data.svgUid).getSize(type);
    }

    getChildren(){

        this.isHover = false;
        let model = this.getByUid(this.data.svgUid).models['pack'];
        if(model.status == 'waiting'){
            return extend({
                properties: {
                    data: {
                        width: this.getByUid(this.data.svgUid).width,
                        height: this.getByUid(this.data.svgUid).height
                    }
                }
            }, Loader);
        }else if(model.status == 'failed'){
            // return extend({}, ErrorMessage);
        }else if(model.status == 'success'){
            // load the items.
            let children = [];
            let circles = getCircles(model.data, this.data.width, 
                    this.data.height, this.data.minScaleFactor);
            for(let c of circles){
                children.push(this.getCircleGroup(c));
            }
            return children;
        }
        
        return [];
    }

    getCircleGroup(data){
        // note that we put data in the private property,
        // because we should not iterate that object. We
        // include some properties the public list to be
        // able to detect changes (and easy access).
        let sP = this.getByUid(this.data.svgUid);
        return extend({
            uid: 'packCircle_'+ data.id,
            properties: {
                data: { 
                    packUid: this.uid,
                    dimension: data.type,
                    name: data.name,
                    id: data.id,
                    icon: data.icon,
                    value: data.value,
                    initialPosition: [data.position.x, data.position.y],
                    opacity: sP.data.opacity,
                    showValueOnHover: sP.data.showValueOnHover
                }
            },
            private: data
        }, CircleGroup);
    }

    setHover(isHover){
        this.isHover = isHover;
        this.trigger('hover');
    }

    checkReset(){
        let v = state.get('filter.theme');
        if(! v){
            this.update();
        }
    }

}



let Blueprint = SvgWrapper({
    type: Controller,
    properties: { 
        data: {
            svgUid: '',
            width: (ctrl) => ( ctrl.getSize('w') ),
            height: (ctrl) => ( ctrl.getSize('h') ),
            minScaleFactor: (ctrl) => ( ctrl.parent.parent.data.minScaleFactor )
        }
     },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.getByUid(ctrl.data.svgUid).models['pack']) ), // should return the id of listener
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'windowSize.width') ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.checkReset], 'filter.theme') )
    ],
    children: [
        (ctrl) => ( ctrl.getChildren() )
    ],
    events: {
        mouseover: (event, ctrl) => ( ctrl.setHover(true) ),
        mouseout: (event, ctrl) => ( ctrl.setHover(false) )
    }    
}, 
{
    properties: {
        data: {
            width: 'auto',
            height: 500,
            minScaleFactor: 0.5,
            opacity: 0.85,
            showValueOnHover: false
        }
    },
    models: {
        'pack': null
    }
});


let Loader = extend({
    properties: {
        data: {
            size: 30,
            width: 500,
            height: 200,
        }
    }
}, BlueprintLoadingSvg);


export default Blueprint;
export {PublicInterface};

    